module.exports = __webpack_public_path__ + "static/media/mimi5.609127cb.gif";